import Papa from 'papaparse';

// The charges table of the "Send to CargoWise" dialog as a CSV, one row per charge line, built
// from the same rows the table shows (so it carries every edit made in the dialog).
const CSV_COLUMNS = [
    ['Field', r => r.Description],
    ['Charge Code', r => r['ChargeCode-Code']],
    ['Sell Amount', r => r.SellOSAmount],
    ['Sell Currency', r => r['SellOSCurrency-Code']],
    ['Cost Amount', r => r.CostOSAmount],
    ['Cost Currency', r => r['CostOSCurrency-Code']],
    ['Creditor', r => r.CreditorName],
    ['Creditor Code', r => r['Creditor-Key']],
    ['Debtor', r => r.DebtorName],
    ['Debtor Code', r => r['Debtor-Key']],
    ['Branch', r => r['Branch-Code']],
    ['Department', r => r['Department-Code']],
];

function chargeLinesToCsv(rows) {
    return Papa.unparse({
        fields: CSV_COLUMNS.map(([ title ]) => title),
        data: (rows || []).map(row => CSV_COLUMNS.map(([ , get ]) => get(row) ?? '')),
    });
}

// Saves text as a file in the browser. The BOM lets Excel read € and £ in a CSV correctly.
function downloadTextFile({ text, filename, type }) {
    const blob = new Blob([ type === 'text/csv' ? '﻿' + text : text ], { type: `${type};charset=utf-8` });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}

export { chargeLinesToCsv, downloadTextFile };
